import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { AuthConfig } from 'shared';

@Injectable({ providedIn: 'root' })
export class AuthConfigRepositoryService {
    private initialized = false;
    private readonly _config: ReplaySubject<AuthConfig> = new ReplaySubject<AuthConfig>(1);
    public readonly config: Observable<AuthConfig> = this._config.asObservable();

    public async initialize(config: AuthConfig): Promise<void> {
        if (this.initialized) {
            console.warn('Baseflow AuthConfigService cannot be initialized more than once.');
            return;
        }
        this.checkForConfigurationIssues(config);

        this._config.next(config);
        this.initialized = true;
    }

    private checkForConfigurationIssues(config: AuthConfig): void {
        if (config.baseUrl.match(/v[0-9]\/?$/)) {
            console.warn('Baseflow AuthConfigService: The baseUrl should not end with a version number.');
        }
    }
}
